var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpyro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_386",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29249",
    "data-name": "Group 29249",
    transform: "translate(583 10935)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -583, -10935)",
    filter: "url(#Ellipse_386)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_386-2",
    "data-name": "Ellipse 386",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-spyro_1_",
    "data-name": "icons8-spyro (1)",
    transform: "translate(-564.722 -10918.961)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50122",
    "data-name": "Path 50122",
    d: "M33.536,17.425s1.518-.759,5.315-.759a9.461,9.461,0,0,0-7.995-6.319l-.743-.089,1.9-5.74c-7.592,0-9.87,3.037-9.87,3.037.178-1.487.963-4.188,2.278-4.555-7.592,0-8.352,5.315-8.352,5.315S13.8,6.8,13.8,3C11.518,4.518,10,6.037,10,9.833a9.212,9.212,0,0,0,.759,3.8l16.7,22.018h5.315a5.809,5.809,0,0,0-1.518-3.8,9.624,9.624,0,0,1,4.555,1.518,14.726,14.726,0,0,0-2.278-8.352,10.5,10.5,0,0,1,5.315,1.518C38.851,20.462,33.536,17.425,33.536,17.425Z",
    transform: "translate(-2.408 -0.723)",
    fill: "#fbc02d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50123",
    "data-name": "Path 50123",
    d: "M30.61,24.148c0,4.745-3.8,9.111-3.8,9.111v4.464l-12.148.091V34.777s-7.57,0-10.887-1.518c-.008,0-.008-.008-.015-.008L3.278,31.74H2.518A7.6,7.6,0,0,1,1,27.185v-.759c0-.759.547-.759.759-.759H6.315V19.592s-1.42-.683-1.518-1.518A9.057,9.057,0,0,1,6.5,15.8c3.515-3.128,7.4-3.8,11.958-3.8A11.977,11.977,0,0,1,30.61,24.148Z",
    transform: "translate(-0.241 -2.89)",
    fill: "#673ab7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50124",
    "data-name": "Path 50124",
    d: "M.759,31.278a5.022,5.022,0,0,0,.759-1.518A.76.76,0,0,0,.759,29,.809.809,0,0,0,0,29.854,1.76,1.76,0,0,0,.759,31.278Z",
    transform: "translate(0 -6.983)",
    fill: "#673ab7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50125",
    "data-name": "Path 50125",
    d: "M12.555,26.592V19l-3.037.759L8,22.037s1.518.131,1.518,1.518v3.037Z",
    transform: "translate(-1.926 -4.575)",
    fill: "#512da8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50126",
    "data-name": "Path 50126",
    d: "M16.208,29.285H12V23.97c0-4.555,5.315-4.555,5.315,1.518C17.315,28.526,16.208,29.285,16.208,29.285Z",
    transform: "translate(-2.889 -4.99)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50127",
    "data-name": "Path 50127",
    d: "M13.427,27.555c.888,0,1.61-1.02,1.61-2.278S14.316,23,13.427,23a1.408,1.408,0,0,0-1.389,1.348c-.023.282-.038.592-.038.929s.015.638.03.911A1.4,1.4,0,0,0,13.427,27.555Z",
    transform: "translate(-2.889 -5.538)",
    fill: "#ab47bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50128",
    "data-name": "Path 50128",
    d: "M13.518,25.518c0,.84-.38,1.518-.85,1.518-.258,0-.668-.253-.668-1.518S12.418,24,12.668,24C13.139,24,13.518,24.678,13.518,25.518Z",
    transform: "translate(-2.889 -5.779)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50129",
    "data-name": "Path 50129",
    d: "M14.759,23a.759.759,0,1,0,.759.759A.759.759,0,0,0,14.759,23Z",
    transform: "translate(-3.371 -5.538)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50130",
    "data-name": "Path 50130",
    d: "M33.139,24C32.51,24,32,24.68,32,25.518s.51,1.518,1.139,1.518,1.139-.68,1.139-1.518S33.768,24,33.139,24ZM35.8,26.278c-.759,0-.759.664-.759.949,0,.38.569,1.329.759,1.329s.759-.854.759-1.329C36.555,26.942,36.555,26.278,35.8,26.278Zm-2.278,2.278c-.759,0-.759.664-.759.949,0,.38.569,1.329.759,1.329s.759-.854.759-1.329C34.278,29.22,34.278,28.555,33.518,28.555Z",
    transform: "translate(-7.705 -5.779)",
    fill: "#512da8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50131",
    "data-name": "Path 50131",
    d: "M17.944,28c-3.037,0-3.8,2.278-6.074,2.278-1.9,0-2.278-1.234-2.278-1.518H8.074L6.555,28A9.624,9.624,0,0,1,2,29.518s3.037,3.037,9.111,3.037a6.651,6.651,0,0,0,4.555-1.518,3.583,3.583,0,0,0,2.278.759c1.677,0,3.037-.85,3.037-1.9S19.621,28,17.944,28Z",
    transform: "translate(-0.482 -6.742)",
    fill: "#764ebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50132",
    "data-name": "Path 50132",
    d: "M17.666,35.759v1.518a5.767,5.767,0,0,1-2.468-.509C11.942,38.546,8.107,38.8,4.759,38.8H4.5c-.008,0-.008-.008-.015-.008L4,37.278h.759c3.439,0,7.038-.243,10.052-2.035l.41-.243.395.266A3.894,3.894,0,0,0,17.666,35.759ZM24.5,37.278s-.759,3.037-6.074,3.037v1.518C19.185,41.833,24.5,41.833,24.5,37.278Z",
    transform: "translate(-0.963 -8.427)",
    fill: "#4a148c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28944",
    "data-name": "Group 28944",
    transform: "translate(14.425 31.887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50133",
    "data-name": "Path 50133",
    d: "M19,42h3.037v3.037H19Z",
    transform: "translate(-19 -42)",
    fill: "#fbc02d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50134",
    "data-name": "Path 50134",
    d: "M19,42h3.037v1.518H19Z",
    transform: "translate(-19 -42)",
    fill: "#ff8f00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28945",
    "data-name": "Group 28945",
    transform: "translate(4.555 12.147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50135",
    "data-name": "Path 50135",
    d: "M13.411,20.037c-2.374,0-2.332,1.518-5.411,1.518,0,0,2.139-3.8,5.218-3.8A32.19,32.19,0,0,0,20.148,17s-.759,3.037-3.037,3.037Z",
    transform: "translate(-6.482 -16.241)",
    fill: "#311b92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50136",
    "data-name": "Path 50136",
    d: "M19.666,16.759s-1.518,1.518-6.074,1.518a4.554,4.554,0,0,0-2.927.926c-.912.592-1.992,2.111-3.147,2.111C6.845,21.315,6,19.986,6,19.052a3.713,3.713,0,0,0,2.088-1.059A6.844,6.844,0,0,1,12.833,16,31.328,31.328,0,0,1,19.666,16.759Z",
    transform: "translate(-6 -16)",
    fill: "#7e57c2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28946",
    "data-name": "Group 28946",
    transform: "translate(19.741 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50137",
    "data-name": "Path 50137",
    d: "M42.7.03a5.819,5.819,0,0,0-2.285,1.389,1.815,1.815,0,0,0-.175.167,7.736,7.736,0,0,0-.934,1.071.633.633,0,0,0-.061.091,6.6,6.6,0,0,0-.729,1.313,6.444,6.444,0,0,0-.273.79,5.062,5.062,0,0,0-.144.691,1.536,1.536,0,0,0-.053.334c-.023.213-.038.364-.061.486-.061.554-.038.38-.19,1.648l-.046.4a5.3,5.3,0,0,1-.091.562c-.03.159-.068.342-.121.531a8.265,8.265,0,0,1-.326.941,8.428,8.428,0,0,1-.881,1.617,7.909,7.909,0,0,1-.569.759,9.017,9.017,0,0,1-.7.752c-.2.2-.41.395-.638.585a14.173,14.173,0,0,1-2.437,1.655,3.57,3.57,0,0,1-2.642-.3c-2.187-.919-3.3-2.612-3.341-3.887a1.484,1.484,0,0,1,.106-.736,3.332,3.332,0,0,1,1.025-1.207c.235-.182.44-.326.661-.471a1.342,1.342,0,0,1,.167-.121.421.421,0,0,1,.061-.046c.121-.084.547-.349,1.1-.683h.008c.691-.425,1.579-.941,2.24-1.351A.058.058,0,0,1,31.406,7c.478-.281.835-.509.926-.577.061-.053.114-.091.175-.137s.106-.091.152-.137a6.324,6.324,0,0,0,.881-.995V5.132a6.67,6.67,0,0,0,.562-.995l.159-.342a7.435,7.435,0,0,1,.585-1.033,3.173,3.173,0,0,1,.3-.372,4.138,4.138,0,0,1,.607-.6c.1-.076.2-.152.319-.235a6.566,6.566,0,0,1,1.04-.615.153.153,0,0,0,.061-.03,3.574,3.574,0,0,1,.395-.159,7.956,7.956,0,0,1,.812-.289c.22-.068.44-.121.668-.175A12.59,12.59,0,0,1,40.957.03,12.184,12.184,0,0,1,42.7.03Z",
    transform: "translate(-26.001 0.001)",
    fill: "#ff8f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50138",
    "data-name": "Path 50138",
    d: "M36.334,12.915a9.016,9.016,0,0,1-.7.752c-.2.2-.41.395-.638.585-3.918-.729-5.937-2.908-6.628-4.943a1.343,1.343,0,0,1,.167-.121.421.421,0,0,1,.061-.046c.121-.084.547-.349,1.1-.683C30.124,10.288,32.06,12.475,36.334,12.915Zm1.9-3.849c-.03.159-.068.342-.121.531a8.264,8.264,0,0,1-.326.941c-3.014-.463-4.851-1.807-5.808-3.447.478-.281.835-.509.926-.577.061-.053.114-.091.175-.137s.106-.091.152-.137C34.072,7.745,35.8,8.732,38.232,9.066Zm.585-4.123a5.063,5.063,0,0,0-.144.691,1.537,1.537,0,0,0-.053.334c-.023.213-.038.364-.061.486a7.473,7.473,0,0,1-3.728-2.566,7.435,7.435,0,0,1,.585-1.033,3.173,3.173,0,0,1,.3-.372A5.885,5.885,0,0,0,38.817,4.943Zm2-3.265a7.736,7.736,0,0,0-.934,1.071.633.633,0,0,0-.061.091,5.8,5.8,0,0,1-1.685-2,7.956,7.956,0,0,1,.812-.289c.22-.068.44-.121.668-.175A4.132,4.132,0,0,0,40.814,1.678Z",
    transform: "translate(-26.572 -0.09)",
    fill: "#ff6f00"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpyro);
export default __webpack_public_path__ + "static/media/spyro.5607220f0b1d73f04fe9448697fd97e9.svg";
export { ForwardRef as ReactComponent };